<template>
	<el-form ref="form" :model="form" :rules="rules" label-width="10px">
		<el-form-item>
			<uploader-video v-model="form.tutorialUrl"></uploader-video>
		</el-form-item>
		<el-form-item>
			<el-button type="primary" @click="handleSave">保存</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import { edit, detail } from "@/api/tutorial"
import UploaderVideo from "@/components/UploaderVideo.vue";
export default {
	components: { UploaderVideo },
	data() {
		return {
			form: {
				tutorialUrl: ""
			},
			rules: {
				tutorialUrl: [{ required: true, message: "请上传视频", trigger: "change" }]
			}
		};
	},
	mounted() {
		this.getDetail();
	},
	methods: {
		getDetail() {
			detail().then(({ code, data, message }) => {
				if (code == 200) {
					this.form.tutorialUrl = data;
				} else {
					this.$message.error(message);
				}
			});
		},
		handleSave() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				edit({ tutorialUrl: this.form.tutorialUrl }).then(({ code, message }) => {
					if (code == 200) {
						this.$message.success("保存成功");
					} else {
						this.$message.error(message);
					}
				});
			})
		}
	},
}
</script>

<style></style>